module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/154-swaziland-8548b911198aa3f619fa5099f314a274.svg";